import React from 'react';
import { render } from 'react-dom';
import './index.css';
import Navbar from './components/nav';
import About from './components/about'
import Projects from './components/projects';
import Ref from './components/references';
import Contacts from './components/contacts';

render(
  <React.Fragment>
    window.onload(()=>{alert('Website Under develo...')})
    <Navbar />
    <About />
    <Projects />
    <Ref />
    <Contacts />
  </React.Fragment>,
  document.getElementById("root")
);